export default class BrandingService {
    constructor($http, appConfig) {
        "ngInject";

        this.$http = $http;
        this.appConfig = appConfig;
    }

    list(entityId) {
        return this.$http.get(this.appConfig.apiServiceBaseUri + `api/branding/list/${entityId}`);
    }   

    applyBranding(entityId, templateId, images) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/branding/apply/${entityId}/${templateId}`, images);
    }   
}


// WEBPACK FOOTER //
// ./client/app/common/services/branding.service.js